import type { TranslationFunction } from 'global';

export default function translateEnum(
  a: { [key: string]: string },
  strings: string[],
  t: TranslationFunction,
) {
  return Object.values(a).map((el, index) => {
    return [el, t(strings[index])];
  });
}
